import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import VideoPortada from '../images/video_portada.mp4'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    height: '100vh',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      height: 580
    },
    [theme.breakpoints.down('sm')]: {
      height: 450
    },
    [theme.breakpoints.down('xs')]: {
      height: 480
    }
  },
  videoContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    zIndex: -1,
    overflow: 'hidden'
  },
  headerText: {
    color: 'white',
    zIndex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    width: '100%'
  },
  h1: {
    fontSize: 50,
    maxWidth: 800,
    textShadow: '3px 1px 6px #000',
    textAlign: 'center',
    lineHeight: 1.3,
    fontFamily: 'Roboto Slab',
    [theme.breakpoints.down('md')]: {
      marginTop: 0,
      padding: 10
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 30
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 25
    }
  },
  video: {
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '120%'
    },
    [theme.breakpoints.down('xs')]: {
      width: '200%',
      //paddingBottom: '80%'
      //marginLeft: -50
    }
  },
  li: {
    listStyleType: 'none',
    fontSize: 20,
    width: 320,
    textAlign: 'center',
    background: 'rgba(0,0,0,.7)',
    padding: '20px 20px 30px',
    margin: 10,
    cursor: 'pointer',
    fontFamily: 'Roboto Slab',
    '&:hover': {
      background: 'rgba(2, 127, 128, 0.8)'
    },
    fontWeight: 600,
    [theme.breakpoints.down('xs')]: {
      fontSize: 18,
      padding: 10,
      width: 300
    }
  },
  ul: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    paddingLeft: 0
  },
  iframe: {
    width:'100%',height:0,paddingBottom:'56%',position:'relative',
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '90%'
      //marginLeft: -50
    },
    [theme.breakpoints.down('xs')]: {
      paddingBottom: '125%'
      //marginLeft: -50
    }
  },

}))

const Header = ({ history }) => {
  const classes = useStyles()

  const redirectPage = page => {
    history.push(page)
  }

  return (
    <div className={classes.root}>
      <div className={classes.videoContainer}>
        {/*<video className={classes.video} autoPlay loop muted>
          <source src={VideoPortada} type="video/mp4" />
          Your browser does not support the video tag.
  </video>*/}
        <div className={classes.iframe}><iframe src="https://giphy.com/embed/TiIHR7yu68EbES0muD" width="100%" height="100%" style={{position:'absolute'}} className={classes.video} frameBorder="0" allowFullScreen></iframe></div>
      </div>
      <div className={classes.headerText}>
        <h1 className={classes.h1}>
          Infraestructura natural para recuperar las fuentes de agua
        </h1>
        <ul className={classes.ul}>
          <li
            className={classes.li}
            onClick={() =>
              redirectPage('/resurreccion-bofedales-necesita-lima')
            }
          >
            I. La resurrección de los bofedales que necesita Lima
          </li>
          <li
            className={classes.li}
            onClick={() => redirectPage('/como-cuida-cusco-agua')}
          >
            II .Cómo cuida Cusco el agua que toma
          </li>
          <li
            className={classes.li}
            onClick={() => redirectPage('/fuentes-agua-ciudades-sur-peligro')}
          >
            III. Fuentes de agua para ciudades del sur en peligro
          </li>
        </ul>
      </div>
    </div>
  )
}

Header.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func
  })
}

export default withRouter(Header)
